// extracted by mini-css-extract-plugin
export default {"img":"NFTPreview_img__BEkov","nftpreview":"NFTPreview_nftpreview__cj6-y"};